import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Card from "../Card/Card.jsx";
import customTabsStyle from "../../assets/jss/material-kit-pro-react/components/customTabsStyle.jsx";

class BlackCustomTabs extends React.Component {
    state = {
        value: 0
    };
    handleChange = (event, value) => {
        this.setState({ value });
    };
    render() {
        const {
            classes,
            tabs,
            rtlActive
        } = this.props;
        const tabsContainer = classNames({
            [classes.tabsContainer]: true,
            [classes.tabsContainerRTL]: rtlActive
        });
        return (
            <Card className={classes.compressedCard+" "+classes.blackTransparent}>
                <Tabs
                    classes={{
                        root: classes.customTabsRoot,
                        flexContainer: tabsContainer,
                        indicator: classes.displayNone
                    }}
                    value={this.state.value}
                    onChange={this.handleChange}
                    textColor="inherit"
                >
                    {tabs.map((prop, key) => {
                        let icon = {};
                        if (prop.tabIcon !== undefined) {
                            icon = {
                                icon: <prop.tabIcon className={classes.tabIcon} />
                            };
                        } else {
                            icon = {};
                        }
                        return (
                            <Tab
                                key={key}
                                classes={{
                                    root: classes.customTabRoot,
                                    selected: classes.customTabSelected,
                                    labelContainer: classes.customTabLabelContainer,
                                    wrapper: classes.customTabWrapper,
                                    label: classes.customTabLabel
                                }}
                                {...icon}
                                label={prop.tabName}
                            />
                        );
                    })}
                </Tabs>
                {tabs.map((prop, key) => {
                    if (key === this.state.value) {
                        return <div key={key} className={classes.transparent}>{prop.tabContent}</div>;
                    }
                    return null;
                })}
            </Card>
        );
    }
}

BlackCustomTabs.defaultProps = {
    headerColor: "success"
};

BlackCustomTabs.propTypes = {
    classes: PropTypes.object.isRequired,
    headerColor: PropTypes.oneOf([
        "warning",
        "success",
        "danger",
        "info",
        "primary",
        "rose",
        "blackTransparent"
    ]),
    title: PropTypes.string,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            tabName: PropTypes.string.isRequired,
            tabIcon: PropTypes.func,
            tabContent: PropTypes.node.isRequired
        })
    ),
    rtlActive: PropTypes.bool,
    plainTabs: PropTypes.bool
};

export default withStyles(customTabsStyle)(BlackCustomTabs);



// WEBPACK FOOTER //
// ./src/components/CustomTabs/BlackCustomTabs.js